"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var DEBOUNCE_TIME = 0;
var TypeAhead = /** @class */ (function (_super) {
    __extends(TypeAhead, _super);
    function TypeAhead(props) {
        var _this = _super.call(this, props) || this;
        _this.getSuggestions = debounce_1.default(function (q) { return __awaiter(_this, void 0, void 0, function () {
            var response, items, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 7]);
                        return [4 /*yield*/, this.forceSetState({ isLoading: true })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.makeSuggestionsRequest({
                                q: q,
                                size: this.props.maxResults || TypeAhead.defaultProps.maxResults,
                            })];
                    case 2:
                        response = _a.sent();
                        items = this.props.getSuggestionsFromResponse(response);
                        return [4 /*yield*/, this.forceSetState({ suggestionsList: items, isLoading: false })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 4:
                        err_1 = _a.sent();
                        if (!(err_1.name !== 'AbortError')) return [3 /*break*/, 6];
                        // this.showErrorMessage(this.props.errorMessageText || '');
                        return [4 /*yield*/, this.forceSetState({ isLoading: false })];
                    case 5:
                        // this.showErrorMessage(this.props.errorMessageText || '');
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); }, DEBOUNCE_TIME, { leading: true, trailing: true });
        _this.handleSelect = function (selected) {
            if (_this.state.searchValue === _this.lastSubmit || // when the search or the selected are the same does not need to do anything
                (selected && selected.text === _this.lastSubmit)) {
                _this.setState({
                    didNotSelect: false,
                });
                return;
            }
            if (!selected) {
                if (!_this.state.searchValue) {
                    _this.submit();
                }
                else {
                    return;
                }
            }
            else {
                _this.submit({
                    displayName: selected.text || '',
                    value: selected.value,
                    itemData: selected.itemData,
                    optionLabel: selected.text || '',
                });
                _this.setState({
                    searchValue: selected.text || '',
                });
            }
        };
        _this.handleChange = function (currentInputString) {
            if (_this.props.onInputChange) {
                _this.props.onInputChange(currentInputString);
            }
            if (currentInputString.length >=
                (_this.props.minSearchLength || TypeAhead.defaultProps.minSearchLength)) {
                _this.getSuggestions(currentInputString);
            }
            _this.setState({
                searchValue: currentInputString,
            });
        };
        _this.handleInputReset = function () {
            if (_this.props.handleResetInput) {
                _this.props.handleResetInput();
            }
            _this.setState({
                suggestionsList: [],
                searchValue: '',
            });
        };
        _this.handleOnFocus = function (element) {
            _this.setState({
                didNotSelect: false,
            });
            if (_this.props.handleFocusEvent) {
                _this.props.handleFocusEvent(element);
            }
        };
        _this.handleBlur = function (currentText) {
            if (_this.props.handleBlurEvent && // trigger onblur only if values has changed
                currentText !== _this.lastSubmit) {
                _this.props.handleBlurEvent(currentText);
                if (!currentText) {
                    _this.lastSubmit = '';
                }
            }
            if (_this.state.searchValue.trim() && _this.state.searchValue !== _this.lastSubmit) {
                _this.setState({
                    didNotSelect: true,
                });
            }
        };
        _this.submit = function (selected) {
            _this.setState({
                selected: selected,
                suggestionsList: [],
                didNotSelect: false,
            });
            _this.lastSubmit = selected ? selected.displayName : '';
            _this.props.onSelect(selected && selected.itemData);
        };
        _this.state = {
            didNotSelect: false,
            selected: {
                value: props.defaultSelectedValue || '',
                displayName: props.defaultSelectedText || '',
                optionLabel: props.defaultSelectedText || '',
            },
            isLoading: false,
            suggestionsList: [],
            searchValue: props.defaultSelectedText || '',
        };
        _this.lastSubmit = props.defaultSelectedText || '';
        return _this;
    }
    TypeAhead.prototype.forceSetState = function (state) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.setState(state, resolve);
        });
    };
    TypeAhead.prototype.render = function () {
        var errorOnEmptyValue = this.props.errorOnEmptyValue;
        var _a = this.state, suggestionsList = _a.suggestionsList, isLoading = _a.isLoading;
        var didNotSelect = this.state.didNotSelect;
        var notFound = !isLoading &&
            suggestionsList.length < 1 &&
            this.state.searchValue.trim() !== '' &&
            this.state.searchValue !== this.lastSubmit;
        var emptyValueError = errorOnEmptyValue && !this.state.searchValue.trim();
        return this.props.children({
            error: notFound || didNotSelect || emptyValueError || false,
            isLoading: isLoading,
            onInputBlur: this.handleBlur,
            onInputChange: this.handleChange,
            onInputFocus: this.handleOnFocus,
            onResetInput: this.handleInputReset,
            onSelect: this.handleSelect,
            suggestionsList: suggestionsList,
        });
    };
    TypeAhead.defaultProps = {
        maxResults: 10,
        minSearchLength: 1,
    };
    return TypeAhead;
}(react_1.default.PureComponent));
exports.default = TypeAhead;
//# sourceMappingURL=TypeAhead.js.map